import '../../sass/blocks/custom/layout/_aging-with-purpose-logo.scss'
require('../../js/blocks/aging-with-purpose-logo.js');